// Presentation-only transforms for the native, authenticated report API.
export const localeTag = locale => locale.replace(/_/g, '-');
export function reportRange(days, now = new Date()) {
  const first = new Date(now);
  first.setHours(0, 0, 0, 0);
  first.setDate(first.getDate() - days + 1);
  return { from: Math.floor(first.getTime() / 1000), to: Math.floor(now.getTime() / 1000) };
}

export function readMetrics(data) {
  const keys = ['open', 'unassigned', 'unattended', 'pending'];
  if (!data || keys.some(key => !Number.isFinite(data[key]) || data[key] < 0)) {
    throw new Error('Invalid conversation metric response');
  }
  return Object.fromEntries(keys.map(key => [key, data[key]]));
}

export function mergeSeries(incoming, outgoing, range) {
  const read = rows => {
    if (!Array.isArray(rows)) throw new Error('Invalid report series');
    return rows.map(row => {
      if (!Number.isFinite(row.timestamp) || !Number.isFinite(row.value) || row.value < 0) {
        throw new Error('Invalid report bucket');
      }
      return row;
    }).filter(row => row.timestamp >= range.from && row.timestamp <= range.to);
  };
  const a = read(incoming), b = read(outgoing);
  const stamps = [...new Set([...a, ...b].map(row => row.timestamp))].sort((x, y) => x - y);
  // Missing buckets stay unknown, not fabricated zero values.
  return stamps.map(timestamp => ({ timestamp,
    incoming: a.find(row => row.timestamp === timestamp)?.value ?? null,
    outgoing: b.find(row => row.timestamp === timestamp)?.value ?? null,
  }));
}

export function chartGeometry(rows, key, maximum, width = 880) {
  const x = index => 48 + index * ((width - 76) / Math.max(rows.length - 1, 1));
  const y = value => 232 - (value / Math.max(maximum, 1)) * 196;
  const segments = [];
  let current = [];
  rows.forEach((row, index) => {
    if (row[key] === null) {
      if (current.length) segments.push(current);
      current = [];
    } else current.push([x(index), y(row[key])]);
  });
  if (current.length) segments.push(current);
  return segments.map(points => ({
    line: points.map(([px, py], index) => `${index ? 'L' : 'M'}${px},${py}`).join(' '),
    area: `M${points[0][0]},232 ${points.map(([px, py]) => `L${px},${py}`).join(' ')} L${points.at(-1)[0]},232 Z`,
  }));
}
